module.exports = __webpack_public_path__ + "static/img/process4.071955f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/process/process4.jpg
// module id = oQRy
// module chunks = 0